import "./App.scss";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Layout from "./components/appLayout/layout";
import { HomePage } from "./pages/homePage";
import ContactSection from "./pages/contactPage";
import { AproposPage } from "./pages/aproposPage";
import { RejoignezPage } from "./pages/RejoignezPage";
import { Consulting } from "./pages/onsultingPage";
import { Advisory } from "./pages/advisory";
import { Intelligence } from "./pages/Intelligence";
import { Technologique } from "./pages/Technologique";
import LoginPage from "./pages/adminPages/loginPage";
import VerifCode from "./pages/adminPages/verifCodePage";
import ProtectedRoute from "./pages/adminPages/protectedRoute";
import AppLayoutAdmin from "./pages/adminPages/appLayoutAdmin";
import Dashbord from "./pages/adminPages/dashbordAdmin";
import RealisationListePages from "./pages/adminPages/realisationListe/realisationListe";
import DemandeOffreListe from "./pages/adminPages/demandeOffreListe";
import ContactListe from "./pages/adminPages/contactList";
import UserListePages from "./pages/adminPages/userListe";
import RealisationForm from "./pages/adminPages/addRealisation";
import NewslettreListe from "./pages/adminPages/NewsLetter";
import MissionListe from "./pages/adminPages/listeMissionPage";
import JobForm from "./pages/adminPages/addMissionPage";
import { Blogs } from "./pages/blogs";
import { BlogDetails } from "./pages/blogDetails";
import CandidatureListe from "./pages/adminPages/candidatureListe";
import MentionsLegales from "./pages/mentionLegal";

function App() {
  return (
    <>
      <ToastContainer position="top-right" />
      <Router>
        <Routes>
          <Route
            path="/"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          <Route
            path="/mentions-legales"
            element={
              <Layout>
                <MentionsLegales />
              </Layout>
            }
          />
          <Route
            path="/contact"
            element={
              <Layout>
                <ContactSection />
              </Layout>
            }
          />
          <Route
            path="/apropos"
            element={
              <Layout>
                <AproposPage />
              </Layout>
            }
          />
          <Route
            path="/rejoignez-msit"
            element={
              <Layout>
                <RejoignezPage />
              </Layout>
            }
          />
          <Route
            path="/bu-msit-advisory"
            element={
              <Layout>
                <Consulting />
              </Layout>
            }
          />{" "}
          <Route
            path="/bu-msit-services"
            element={
              <Layout>
                <Advisory />
              </Layout>
            }
          />
          <Route
            path="/bu-msit-ai"
            element={
              <Layout>
                <Intelligence />
              </Layout>
            }
          />
          <Route
            path="/bu-msit-conseil"
            element={
              <Layout>
                <Technologique />
              </Layout>
            }
          />
          <Route
            path="/blogs"
            element={
              <Layout>
                <Blogs />
              </Layout>
            }
          />
          <Route
            path="/blogDetails/:id"
            element={
              <Layout>
                <BlogDetails />
              </Layout>
            }
          />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/verif-code" element={<VerifCode />} />
          <Route
            path="/dashbord"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <Dashbord />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/candidature-liste"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <CandidatureListe />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/realisation-liste"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <RealisationListePages />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/newsletter-liste"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <NewslettreListe />
                </AppLayoutAdmin>{" "}
              </ProtectedRoute>
            }
          />
          <Route
            path="/demande-pack"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <DemandeOffreListe />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/contact-liste"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <ContactListe />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/user-liste"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <UserListePages />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-realisation"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <RealisationForm />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-realisation/:id"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <RealisationForm />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/add-mission"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <JobForm />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
          <Route
            path="/edit-mission/:id"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <JobForm />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />{" "}
          <Route
            path="/mission-liste"
            element={
              <ProtectedRoute>
                <AppLayoutAdmin>
                  <MissionListe />
                </AppLayoutAdmin>
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </>
  );
}

export default App;
